module.exports = __webpack_public_path__ + "img/imge3.2e186811.png";